import React from 'react';

const SettingIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <svg
      onClick={onClick}
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5405 8.2589L21.8662 7.0888C21.2958 6.09871 20.0316 5.75716 19.0401 6.32526V6.32526C18.5682 6.60327 18.0051 6.68215 17.4749 6.54449C16.9448 6.40684 16.4911 6.06396 16.2141 5.59147C16.0358 5.29114 15.94 4.94907 15.9364 4.59986V4.59986C15.9525 4.03997 15.7413 3.49742 15.3508 3.09579C14.9604 2.69416 14.4241 2.46766 13.8639 2.4679H12.5054C11.9567 2.46789 11.4306 2.68655 11.0435 3.0755C10.6564 3.46445 10.4403 3.99162 10.4429 4.54036V4.54036C10.4266 5.67332 9.5035 6.58319 8.37043 6.58308C8.02121 6.57945 7.67914 6.48367 7.37882 6.30542V6.30542C6.38738 5.73733 5.12319 6.07888 4.55273 7.06896L3.82885 8.2589C3.25909 9.24774 3.596 10.5111 4.58248 11.085V11.085C5.22371 11.4552 5.61872 12.1394 5.61872 12.8798C5.61872 13.6202 5.22371 14.3044 4.58248 14.6746V14.6746C3.59725 15.2446 3.25998 16.5049 3.82885 17.4908V17.4908L4.51307 18.6708C4.78035 19.1531 5.2288 19.509 5.75919 19.6597C6.28958 19.8105 6.85817 19.7436 7.33915 19.474V19.474C7.81198 19.1981 8.37543 19.1225 8.90426 19.264C9.43309 19.4055 9.88348 19.7524 10.1553 20.2276C10.3336 20.5279 10.4293 20.87 10.433 21.2192V21.2192C10.433 22.3638 11.3608 23.2917 12.5054 23.2917H13.8639C15.0047 23.2917 15.9309 22.3699 15.9364 21.2291V21.2291C15.9338 20.6787 16.1512 20.15 16.5405 19.7608C16.9297 19.3715 17.4584 19.154 18.0089 19.1567C18.3573 19.166 18.6979 19.2614 19.0005 19.4343V19.4343C19.9893 20.0041 21.2527 19.6672 21.8266 18.6807V18.6807L22.5405 17.4908C22.8169 17.0164 22.8927 16.4515 22.7513 15.9211C22.6098 15.3906 22.2627 14.9384 21.7869 14.6647V14.6647C21.3111 14.3909 20.964 13.9388 20.8225 13.4083C20.6811 12.8779 20.7569 12.313 21.0333 11.8386C21.213 11.5248 21.4731 11.2647 21.7869 11.085V11.085C22.7675 10.5114 23.1036 9.25543 22.5405 8.26881V8.26881V8.2589Z"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <ellipse
        cx="13.1898"
        cy="12.8798"
        rx="2.85584"
        ry="2.85583"
        stroke="#7A7A7A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SettingIcon;
